module.exports = ".gm-style div {\n  color: #fff !important;\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/browserequest/browserequest.component.scss
// module id = ./src/app/seller/browserequest/browserequest.component.scss
// module chunks = main